import { GraphQLObjectType, GraphQLNonNull, GraphQLList } from 'graphql'
import {
  TermBucket,
  TermBucketType,
  ApplicationBucket,
  ApplicationBucketType
} from './bucket'

export interface ServerAggregation {
  readonly tags: TermBucket[]
  readonly agentVersions: TermBucket[]
  readonly environments: TermBucket[]
  readonly logLevels: TermBucket[]
  readonly applications: ApplicationBucket[]
}

export const ServerAggregationType = new GraphQLObjectType({
  name: 'ServerAggregation',
  description:
    'The categories of buckets and their values that together make up an aggregation of a collection of servers known to Contrast.',
  fields: () => ({
    tags: {
      type: new GraphQLNonNull(new GraphQLList(TermBucketType))
    },
    agentVersions: {
      type: new GraphQLNonNull(new GraphQLList(TermBucketType))
    },
    environments: {
      type: new GraphQLNonNull(new GraphQLList(TermBucketType))
    },
    logLevels: {
      type: new GraphQLNonNull(new GraphQLList(TermBucketType))
    },
    applications: {
      type: new GraphQLNonNull(new GraphQLList(ApplicationBucketType))
    }
  })
})
